import React, { useEffect } from "react"
// nodejs library that concatenates classes
import classNames from "classnames"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

import "typeface-roboto"
import "typeface-roboto-slab"

import Parallax from "components/Parallax/Parallax.jsx"
import landingPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx"

// core components
import Header from "components/Header/Header.jsx"
import Footer from "components/Footer/Footer.jsx"
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import Button from "components/CustomButtons/Button.jsx"
import HeaderLinks from "components/Header/HeaderLinks.jsx"

import Wrapper from "components/Wrapper/Wrapper.js"



const DemoPage = (props) => {
    const { classes, ...rest } = props

    useEffect(() => {
        const script = document.createElement('script');

        script.src = "https://assets.calendly.com/assets/external/widget.js";
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        }
    }, []);




    return (
        <>
            <Wrapper>
                <Parallax
                    filter

                    style={{ backgroundColor: "#005b9a", height: '35vh' }}
                >
                    <div className={classes.container} style={{ textAlign: 'center' }}>
                        <h2 className={classes.title}>
                            Book a 15 minute demo
                        </h2>
                    </div>
                </Parallax>
                <div className={classNames(classes.main, classes.mainRaised)}>
                    <div className={classes.container} style={{ height: '900px' }}>

                        <div class="calendly-inline-widget" data-url="https://calendly.com/alexprivasee/demo" style={{ minWidth: '320px', height: '800px', marginBottom: '66px' }}></div>


                    </div>
                </div>


            </Wrapper>
        </>
    )

}

export default withStyles(landingPageStyle)(DemoPage)
